import { Reveal, SectionLabel } from "./Reveal";
import { Icon } from "@/lib/icons";

export default function About({ site }) {
  const a = site?.about || {};
  return (
    <section id="about" className="py-24 lg:py-32 bg-[var(--c-bg)] relative paper-texture">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <SectionLabel>{a.label || "আমাদের পরিচয়"}</SectionLabel>
          <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{a.title}</h2>
          <p className="font-body text-base sm:text-lg text-[var(--c-muted)] max-w-3xl mx-auto mt-6 leading-relaxed">{a.intro}</p>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-14 items-center mt-16">
          <Reveal y={40}>
            <div className="relative">
              <img src={a.image1} alt={a.title} loading="lazy" className="w-2/3 rounded-2xl object-cover h-[360px] shadow-lg border border-[var(--c-border)]" />
              {a.image2 && (
                <img src={a.image2} alt={a.title} loading="lazy" className="absolute bottom-[-30px] right-0 w-1/2 rounded-2xl object-cover h-[240px] shadow-xl border-4 border-[var(--c-bg)]" />
              )}
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div>
              <p className="font-body text-[var(--c-text)]/90 text-base sm:text-lg leading-relaxed">{a.para1}</p>
              <p className="font-body text-[var(--c-muted)] text-base leading-relaxed mt-5">{a.para2}</p>
              <div className="grid sm:grid-cols-2 gap-x-8 gap-y-5 mt-9">
                {(a.features || []).map((f, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <span className="grid place-items-center h-11 w-11 rounded-full bg-[var(--c-bg-alt)] text-[var(--c-secondary)] border border-[var(--c-border)]">
                      <Icon name={f.icon} className="h-5 w-5" />
                    </span>
                    <span className="font-body text-[var(--c-text)]">{f.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
